import { createRef, Fragment, RefObject, useLayoutEffect, useState } from 'react';
import Frame from 'react-frame-component';

import useDebouncedCallback from '~hooks/useDebouncedCallback';
import { useUiComponentCss } from '~modules/ui-component-css/UiComponentCssContext';
import { convertToRawValue } from '~services/data-conversion';

interface FrameRef extends HTMLIFrameElement {
  node: HTMLIFrameElement;
}

export type PreviewStageProps = {
  code: string;
};

const PreviewStage = ({ code }: PreviewStageProps) => {
  const { cssString, cssFile } = useUiComponentCss();
  const cleanData = convertToRawValue(code);
  const [height, setHeight] = useState(200);
  const iframeRef = createRef<FrameRef>();

  const handleDebouncedResize = useDebouncedCallback((iframe: RefObject<FrameRef>) => {
    let contentHeight = 0;
    if (iframe.current?.node?.contentDocument?.body) {
      const divContent = iframe.current.node.contentDocument.body.querySelector<HTMLDivElement>('.frame-content');
      if (divContent) {
        contentHeight = divContent.offsetHeight;
      }
    }
    if (contentHeight !== 0) {
      setHeight(contentHeight);
    }
  }, 150);

  useLayoutEffect(() => {
    handleDebouncedResize(iframeRef);
  }, [handleDebouncedResize, iframeRef]);

  return (
    <div className="c-ui-component--preview">
      <Frame
        className="c-ui-component--preview-frame"
        frameBorder="0"
        ref={iframeRef}
        style={{
          height,
          minHeight: '100%',
          minWidth: '100%',
        }}
        head={
          <Fragment>
            <style>{`
      html, body {
        margin: 0;
        padding: 0;
        height: 100%;
      }
      html > body > div:first-child {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
      }
        `}</style>
            {!!cssFile && <link rel="stylesheet" href={cssFile} />}
            {!!cssString && <style>{cssString}</style>}
          </Fragment>
        }
      >
        <div dangerouslySetInnerHTML={{ __html: cleanData }} />
      </Frame>
    </div>
  );
};

export default PreviewStage;
